const KNOWN_GROUP_NAMES: Record<string, string> = {
  machines: 'Maskiner',
  'laser machines': 'Lasermaskiner',
};

/** Danish label for the English default group names. A clinic's own name is left as stored. */
export function displayResourceGroupName(name: string): string {
  return KNOWN_GROUP_NAMES[name.trim().toLowerCase()] ?? name;
}
